import { getResponse } from '@satellite/services/serviceUtilities';

/**
 * Reporting service for analytics and reporting operations.
 */
export default {
  /**
   * Gets a pre-authenticated redirect URL for the Analytics Portal.
   *
   * Generates a short-lived JWT token (1 day expiration) with audience 'analytics-portal'
   * and requests a redirect URL from the Analytics Portal API. The returned URL can be
   * used to redirect users to the external Analytics Portal in a pre-authenticated fashion.
   *
   * Uses axios.get to call /reporting/analytics-portal endpoint and getResponse to unwrap
   * the response data.
   *
   * @async
   * @param {Object} [options={}] - Options for response processing via getResponse
   * @param {boolean} [options.includeMetaData] - If true, returns the full axios response instead of unwrapped data
   * @param {Object} [requestConfig={}] - Axios request configuration (headers, timeout, etc.)
   * @returns {Promise<{redirectUrl: string}>} Promise resolving to object containing the Analytics Portal redirect URL
   *
   * @example
   * const response = await this.services.reporting.getAnalyticsPortalRedirect();
   * if (response?.redirectUrl) {
   *   const newWindow = window.open(response.redirectUrl, '_blank', 'noopener,noreferrer');
   *   if (newWindow) newWindow.opener = null;
   * }
   */
  async getAnalyticsPortalRedirect(options = {}, requestConfig = {}) {
    const response = await axios.get('/reporting/analytics-portal', requestConfig);
    return getResponse(response, options);
  }
};
